/* eslint-disable no-bitwise */
// Gedcom person utility methods

const GEDCOM_PREFIX = 'http://gedcomx.org/'
const GEDCOM_FIRSTNAME_KEY = `${GEDCOM_PREFIX}Given`
const GEDCOM_LASTNAME_KEY = `${GEDCOM_PREFIX}Surname`

export const getName = (person, nameDelimiter = ' ') => {
  let response = { name: '', firstName: '', lastName: '' }
  if (person) {
    let name
    const firstName = person?.nameParts?.find((part) => part.type === GEDCOM_FIRSTNAME_KEY)?.value

    if (firstName !== undefined) {
      name = firstName
    }

    // the Url has a name parameter with <firstName>_<lastName> value (_ separating first and last name), but if the last name is missing, it causes an error, so we add an underscore to the end of the first name to avoid the error and still get relevant search results
    name += nameDelimiter

    const lastName = person?.nameParts?.find((part) => part.type === GEDCOM_LASTNAME_KEY)?.value

    if (lastName !== undefined) {
      name += lastName
    }
    response = { name, firstName, lastName }
  }

  return response
}

export const getGender = (person) => {
  return person.gender?.toLowerCase() || ''
}

export const getFieldValue = (field) => {
  return field?.normalized?.[0]?.value || field?.original || ''
}
